// eslint-disable-next-line no-undef
export const BASE_URL = process.env.REACT_APP_API_URL;
//"https://api.immozy.de/api/"
//beta url: "https://beta-api.immozy.de/api/"
//staging url: "http://staging-api.immozy.de/api/";
